export default __webpack_public_path__ + "static/media/fs_logo_name26.0272141a.svg";